import { Icon } from "@chakra-ui/react";
import React from "react";

/**
 * Renders the chat icon
 * 
 * @param {Object} props - The props of the component
 * @returns The chat icon
 */
const ChatIcon = (props) => (
  <Icon viewBox="0 0 20 20" fill="none" {...props}>
    <path d="M4 12H12V10H4V12ZM4 9H16V7H4V9ZM4 6H16V4H4V6ZM0 20V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H18C18.55 0 19.0208 0.195833 19.4125 0.5875C19.8042 0.979167 20 1.45 20 2V14C20 14.55 19.8042 15.0208 19.4125 15.4125C19.0208 15.8042 18.55 16 18 16H4L0 20ZM3.15 14H18V2H2V15.125L3.15 14Z" fill="currentColor" />
  </Icon>
);

export default React.memo(ChatIcon);
